"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { TextParagraph, UnorderedList, Heading4, Heading3, Link } from "@ops-gsic/cxp-component-library-react";
import { SectionContentWrapper, SectionWrapper } from "@/styles";
export default function MainInfoSection() {
  const $ = _c(251);
  const t = useTranslations("HomePage");
  let t0;
  if ($[0] !== t) {
    t0 = t("information.whatYouNeed.heading");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Heading3>{t0}</Heading3>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("information.whatYouNeed.ln");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <TextParagraph>{t2}</TextParagraph>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("information.whatYouNeed.ln1");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <li>{t4}</li>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("information.whatYouNeed.ln2");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <li>{t6}</li>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("information.whatYouNeed.ln3");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <li>{t8}</li>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("information.whatYouNeed.ln4");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <li>{t10}</li>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("information.whatYouNeed.ln5");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <li>{t12}</li>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t11 || $[29] !== t13 || $[30] !== t5 || $[31] !== t7 || $[32] !== t9) {
    t14 = <UnorderedList>{t5}{t7}{t9}{t11}{t13}</UnorderedList>;
    $[28] = t11;
    $[29] = t13;
    $[30] = t5;
    $[31] = t7;
    $[32] = t9;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t.rich("information.whatYouNeed.note", {
      location: chunks => <Link href={t("location")} target="_blank">{chunks}</Link>
    });
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15) {
    t16 = <TextParagraph>{t15}</TextParagraph>;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t14 || $[39] !== t16 || $[40] !== t3) {
    t17 = <SectionContentWrapper>{t3}{t14}{t16}</SectionContentWrapper>;
    $[38] = t14;
    $[39] = t16;
    $[40] = t3;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t1 || $[43] !== t17) {
    t18 = <SectionWrapper>{t1}{t17}</SectionWrapper>;
    $[42] = t1;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t) {
    t19 = t("information.whatInfo.heading");
    $[45] = t;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t19) {
    t20 = <Heading3>{t19}</Heading3>;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t) {
    t21 = t("information.whatInfo.ln0");
    $[49] = t;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t21) {
    t22 = <TextParagraph>{t21}</TextParagraph>;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t) {
    t23 = t("information.whatInfo.ln1");
    $[53] = t;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t23) {
    t24 = <li>{t23}</li>;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t) {
    t25 = t("information.whatInfo.ln2");
    $[57] = t;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t25) {
    t26 = <li>{t25}</li>;
    $[59] = t25;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t) {
    t27 = t("information.whatInfo.ln3");
    $[61] = t;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== t27) {
    t28 = <li>{t27}</li>;
    $[63] = t27;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== t) {
    t29 = t("information.whatInfo.ln4");
    $[65] = t;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t29) {
    t30 = <li>{t29}</li>;
    $[67] = t29;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  let t31;
  if ($[69] !== t) {
    t31 = t("information.whatInfo.ln5");
    $[69] = t;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t31) {
    t32 = <li>{t31}</li>;
    $[71] = t31;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== t) {
    t33 = t("information.whatInfo.ln6");
    $[73] = t;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  let t34;
  if ($[75] !== t33) {
    t34 = <li>{t33}</li>;
    $[75] = t33;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] !== t) {
    t35 = t("information.whatInfo.ln7");
    $[77] = t;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] !== t35) {
    t36 = <li>{t35}</li>;
    $[79] = t35;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  let t37;
  if ($[81] !== t) {
    t37 = t("information.whatInfo.ln8");
    $[81] = t;
    $[82] = t37;
  } else {
    t37 = $[82];
  }
  let t38;
  if ($[83] !== t37) {
    t38 = <li>{t37}</li>;
    $[83] = t37;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== t) {
    t39 = t("information.whatInfo.ln9");
    $[85] = t;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  let t40;
  if ($[87] !== t39) {
    t40 = <li>{t39}</li>;
    $[87] = t39;
    $[88] = t40;
  } else {
    t40 = $[88];
  }
  let t41;
  if ($[89] !== t) {
    t41 = t.rich("information.whatInfo.ln10", {
      location: chunks_0 => <Link href={t("location")} target="_blank">{chunks_0}</Link>
    });
    $[89] = t;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== t41) {
    t42 = <li>{t41}</li>;
    $[91] = t41;
    $[92] = t42;
  } else {
    t42 = $[92];
  }
  let t43;
  if ($[93] !== t24 || $[94] !== t26 || $[95] !== t28 || $[96] !== t30 || $[97] !== t32 || $[98] !== t34 || $[99] !== t36 || $[100] !== t38 || $[101] !== t40 || $[102] !== t42) {
    t43 = <UnorderedList>{t24}{t26}{t28}{t30}{t32}{t34}{t36}{t38}{t40}{t42}</UnorderedList>;
    $[93] = t24;
    $[94] = t26;
    $[95] = t28;
    $[96] = t30;
    $[97] = t32;
    $[98] = t34;
    $[99] = t36;
    $[100] = t38;
    $[101] = t40;
    $[102] = t42;
    $[103] = t43;
  } else {
    t43 = $[103];
  }
  let t44;
  if ($[104] !== t22 || $[105] !== t43) {
    t44 = <SectionContentWrapper>{t22}{t43}</SectionContentWrapper>;
    $[104] = t22;
    $[105] = t43;
    $[106] = t44;
  } else {
    t44 = $[106];
  }
  let t45;
  if ($[107] !== t20 || $[108] !== t44) {
    t45 = <SectionWrapper>{t20}{t44}</SectionWrapper>;
    $[107] = t20;
    $[108] = t44;
    $[109] = t45;
  } else {
    t45 = $[109];
  }
  let t46;
  if ($[110] !== t) {
    t46 = t("information.importantInfo.heading");
    $[110] = t;
    $[111] = t46;
  } else {
    t46 = $[111];
  }
  let t47;
  if ($[112] !== t46) {
    t47 = <Heading3>{t46}</Heading3>;
    $[112] = t46;
    $[113] = t47;
  } else {
    t47 = $[113];
  }
  let t48;
  if ($[114] !== t) {
    t48 = t("information.importantInfo.ln1");
    $[114] = t;
    $[115] = t48;
  } else {
    t48 = $[115];
  }
  let t49;
  if ($[116] !== t48) {
    t49 = <li>{t48}</li>;
    $[116] = t48;
    $[117] = t49;
  } else {
    t49 = $[117];
  }
  let t50;
  if ($[118] !== t) {
    t50 = t("information.importantInfo.ln2");
    $[118] = t;
    $[119] = t50;
  } else {
    t50 = $[119];
  }
  let t51;
  if ($[120] !== t50) {
    t51 = <li>{t50}</li>;
    $[120] = t50;
    $[121] = t51;
  } else {
    t51 = $[121];
  }
  let t52;
  if ($[122] !== t) {
    t52 = t("information.importantInfo.ln3");
    $[122] = t;
    $[123] = t52;
  } else {
    t52 = $[123];
  }
  let t53;
  if ($[124] !== t52) {
    t53 = <li>{t52}</li>;
    $[124] = t52;
    $[125] = t53;
  } else {
    t53 = $[125];
  }
  let t54;
  if ($[126] !== t) {
    t54 = t("information.importantInfo.ln4");
    $[126] = t;
    $[127] = t54;
  } else {
    t54 = $[127];
  }
  let t55;
  if ($[128] !== t54) {
    t55 = <li>{t54}</li>;
    $[128] = t54;
    $[129] = t55;
  } else {
    t55 = $[129];
  }
  let t56;
  if ($[130] !== t) {
    t56 = t("information.importantInfo.ln5");
    $[130] = t;
    $[131] = t56;
  } else {
    t56 = $[131];
  }
  let t57;
  if ($[132] !== t56) {
    t57 = <li>{t56}</li>;
    $[132] = t56;
    $[133] = t57;
  } else {
    t57 = $[133];
  }
  let t58;
  if ($[134] !== t49 || $[135] !== t51 || $[136] !== t53 || $[137] !== t55 || $[138] !== t57) {
    t58 = <SectionContentWrapper><UnorderedList>{t49}{t51}{t53}{t55}{t57}</UnorderedList></SectionContentWrapper>;
    $[134] = t49;
    $[135] = t51;
    $[136] = t53;
    $[137] = t55;
    $[138] = t57;
    $[139] = t58;
  } else {
    t58 = $[139];
  }
  let t59;
  if ($[140] !== t47 || $[141] !== t58) {
    t59 = <SectionWrapper>{t47}{t58}</SectionWrapper>;
    $[140] = t47;
    $[141] = t58;
    $[142] = t59;
  } else {
    t59 = $[142];
  }
  let t60;
  if ($[143] !== t) {
    t60 = t("information.whatProduct.heading");
    $[143] = t;
    $[144] = t60;
  } else {
    t60 = $[144];
  }
  let t61;
  if ($[145] !== t60) {
    t61 = <Heading3>{t60}</Heading3>;
    $[145] = t60;
    $[146] = t61;
  } else {
    t61 = $[146];
  }
  let t62;
  if ($[147] !== t) {
    t62 = t("information.whatProduct.subheading");
    $[147] = t;
    $[148] = t62;
  } else {
    t62 = $[148];
  }
  let t63;
  if ($[149] !== t62) {
    t63 = <Heading4>{t62}</Heading4>;
    $[149] = t62;
    $[150] = t63;
  } else {
    t63 = $[150];
  }
  let t64;
  if ($[151] !== t) {
    t64 = t("information.whatProduct.ln0");
    $[151] = t;
    $[152] = t64;
  } else {
    t64 = $[152];
  }
  let t65;
  if ($[153] !== t64) {
    t65 = <TextParagraph>{t64}</TextParagraph>;
    $[153] = t64;
    $[154] = t65;
  } else {
    t65 = $[154];
  }
  let t66;
  if ($[155] !== t) {
    t66 = t("information.whatProduct.ln1");
    $[155] = t;
    $[156] = t66;
  } else {
    t66 = $[156];
  }
  let t67;
  if ($[157] !== t66) {
    t67 = <li>{t66}</li>;
    $[157] = t66;
    $[158] = t67;
  } else {
    t67 = $[158];
  }
  let t68;
  if ($[159] !== t) {
    t68 = t("information.whatProduct.ln2");
    $[159] = t;
    $[160] = t68;
  } else {
    t68 = $[160];
  }
  let t69;
  if ($[161] !== t68) {
    t69 = <li>{t68}</li>;
    $[161] = t68;
    $[162] = t69;
  } else {
    t69 = $[162];
  }
  let t70;
  if ($[163] !== t) {
    t70 = t("information.whatProduct.ln3");
    $[163] = t;
    $[164] = t70;
  } else {
    t70 = $[164];
  }
  let t71;
  if ($[165] !== t70) {
    t71 = <li>{t70}</li>;
    $[165] = t70;
    $[166] = t71;
  } else {
    t71 = $[166];
  }
  let t72;
  if ($[167] !== t) {
    t72 = t("information.whatProduct.ln4");
    $[167] = t;
    $[168] = t72;
  } else {
    t72 = $[168];
  }
  let t73;
  if ($[169] !== t72) {
    t73 = <li>{t72}</li>;
    $[169] = t72;
    $[170] = t73;
  } else {
    t73 = $[170];
  }
  let t74;
  if ($[171] !== t) {
    t74 = t("information.whatProduct.ln5");
    $[171] = t;
    $[172] = t74;
  } else {
    t74 = $[172];
  }
  let t75;
  if ($[173] !== t74) {
    t75 = <li>{t74}</li>;
    $[173] = t74;
    $[174] = t75;
  } else {
    t75 = $[174];
  }
  let t76;
  if ($[175] !== t) {
    t76 = t("information.whatProduct.ln6");
    $[175] = t;
    $[176] = t76;
  } else {
    t76 = $[176];
  }
  let t77;
  if ($[177] !== t76) {
    t77 = <li>{t76}</li>;
    $[177] = t76;
    $[178] = t77;
  } else {
    t77 = $[178];
  }
  let t78;
  if ($[179] !== t75 || $[180] !== t77) {
    t78 = <UnorderedList>{t75}{t77}</UnorderedList>;
    $[179] = t75;
    $[180] = t77;
    $[181] = t78;
  } else {
    t78 = $[181];
  }
  let t79;
  if ($[182] !== t67 || $[183] !== t69 || $[184] !== t71 || $[185] !== t73 || $[186] !== t78) {
    t79 = <UnorderedList>{t67}{t69}{t71}{t73}{t78}</UnorderedList>;
    $[182] = t67;
    $[183] = t69;
    $[184] = t71;
    $[185] = t73;
    $[186] = t78;
    $[187] = t79;
  } else {
    t79 = $[187];
  }
  let t80;
  if ($[188] !== t65 || $[189] !== t79) {
    t80 = <SectionContentWrapper>{t65}{t79}</SectionContentWrapper>;
    $[188] = t65;
    $[189] = t79;
    $[190] = t80;
  } else {
    t80 = $[190];
  }
  let t81;
  if ($[191] !== t61 || $[192] !== t63 || $[193] !== t80) {
    t81 = <SectionWrapper>{t61}{t63}{t80}</SectionWrapper>;
    $[191] = t61;
    $[192] = t63;
    $[193] = t80;
    $[194] = t81;
  } else {
    t81 = $[194];
  }
  let t82;
  if ($[195] !== t) {
    t82 = t("information.cost.heading");
    $[195] = t;
    $[196] = t82;
  } else {
    t82 = $[196];
  }
  let t83;
  if ($[197] !== t82) {
    t83 = <Heading3>{t82}</Heading3>;
    $[197] = t82;
    $[198] = t83;
  } else {
    t83 = $[198];
  }
  let t84;
  if ($[199] !== t) {
    t84 = t("information.cost.ln");
    $[199] = t;
    $[200] = t84;
  } else {
    t84 = $[200];
  }
  let t85;
  if ($[201] !== t84) {
    t85 = <TextParagraph>{t84}</TextParagraph>;
    $[201] = t84;
    $[202] = t85;
  } else {
    t85 = $[202];
  }
  let t86;
  if ($[203] !== t) {
    t86 = t("information.cost.ln0");
    $[203] = t;
    $[204] = t86;
  } else {
    t86 = $[204];
  }
  let t87;
  if ($[205] !== t86) {
    t87 = <TextParagraph>{t86}</TextParagraph>;
    $[205] = t86;
    $[206] = t87;
  } else {
    t87 = $[206];
  }
  let t88;
  if ($[207] !== t) {
    t88 = t("information.cost.ln1");
    $[207] = t;
    $[208] = t88;
  } else {
    t88 = $[208];
  }
  let t89;
  if ($[209] !== t88) {
    t89 = <li>{t88}</li>;
    $[209] = t88;
    $[210] = t89;
  } else {
    t89 = $[210];
  }
  let t90;
  if ($[211] !== t) {
    t90 = t("information.cost.ln2");
    $[211] = t;
    $[212] = t90;
  } else {
    t90 = $[212];
  }
  let t91;
  if ($[213] !== t90) {
    t91 = <li>{t90}</li>;
    $[213] = t90;
    $[214] = t91;
  } else {
    t91 = $[214];
  }
  let t92;
  if ($[215] !== t) {
    t92 = t("information.cost.ln3");
    $[215] = t;
    $[216] = t92;
  } else {
    t92 = $[216];
  }
  let t93;
  if ($[217] !== t92) {
    t93 = <li>{t92}</li>;
    $[217] = t92;
    $[218] = t93;
  } else {
    t93 = $[218];
  }
  let t94;
  if ($[219] !== t) {
    t94 = t("information.cost.ln4");
    $[219] = t;
    $[220] = t94;
  } else {
    t94 = $[220];
  }
  let t95;
  if ($[221] !== t94) {
    t95 = <li>{t94}</li>;
    $[221] = t94;
    $[222] = t95;
  } else {
    t95 = $[222];
  }
  let t96;
  if ($[223] !== t89 || $[224] !== t91 || $[225] !== t93 || $[226] !== t95) {
    t96 = <UnorderedList>{t89}{t91}{t93}{t95}</UnorderedList>;
    $[223] = t89;
    $[224] = t91;
    $[225] = t93;
    $[226] = t95;
    $[227] = t96;
  } else {
    t96 = $[227];
  }
  let t97;
  if ($[228] !== t) {
    t97 = t("information.cost.ln5");
    $[228] = t;
    $[229] = t97;
  } else {
    t97 = $[229];
  }
  let t98;
  if ($[230] !== t97) {
    t98 = <TextParagraph>{t97}</TextParagraph>;
    $[230] = t97;
    $[231] = t98;
  } else {
    t98 = $[231];
  }
  let t99;
  if ($[232] !== t) {
    t99 = t("information.cost.ln6");
    $[232] = t;
    $[233] = t99;
  } else {
    t99 = $[233];
  }
  let t100;
  if ($[234] !== t99) {
    t100 = <TextParagraph>{t99}</TextParagraph>;
    $[234] = t99;
    $[235] = t100;
  } else {
    t100 = $[235];
  }
  let t101;
  if ($[236] !== t100 || $[237] !== t85 || $[238] !== t87 || $[239] !== t96 || $[240] !== t98) {
    t101 = <SectionContentWrapper>{t85}{t87}{t96}{t98}{t100}</SectionContentWrapper>;
    $[236] = t100;
    $[237] = t85;
    $[238] = t87;
    $[239] = t96;
    $[240] = t98;
    $[241] = t101;
  } else {
    t101 = $[241];
  }
  let t102;
  if ($[242] !== t101 || $[243] !== t83) {
    t102 = <SectionWrapper>{t83}{t101}</SectionWrapper>;
    $[242] = t101;
    $[243] = t83;
    $[244] = t102;
  } else {
    t102 = $[244];
  }
  let t103;
  if ($[245] !== t102 || $[246] !== t18 || $[247] !== t45 || $[248] !== t59 || $[249] !== t81) {
    t103 = <>{t18}{t45}{t59}{t81}{t102}</>;
    $[245] = t102;
    $[246] = t18;
    $[247] = t45;
    $[248] = t59;
    $[249] = t81;
    $[250] = t103;
  } else {
    t103 = $[250];
  }
  return t103;
}